module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "menu-vertical-item",
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.icon != '') ? _c('div', {
    staticClass: "menu-icon"
  }, [_c('i', {
    staticClass: "icon iconfont",
    class: [
      _vm.icon != '' ? 'icon-' + _vm.icon : ''
    ]
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menu-body"
  }, [_vm._t("body")], 2), _vm._v(" "), _c('div', {
    staticClass: "menu-dock"
  }, [_vm._t("dock")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-37c09a3f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu-vertical/menu-vertical.vue
// module id = 240
// module chunks = 36